import { AnalyticIdentifier } from '@common/neo.tax';

import { useAnalyticId } from '@neo.tax/shared';

type AscWagesPmeAnalyticIds = {
  payrollMonthExpenseUploadBtnId: string;
  payrollMonthExpenseCancelBtnId: string;
  payrollMonthExpenseUploadInputId: string;
};

export const useAscWagesPmeAnalyticIds = (): AscWagesPmeAnalyticIds => ({
  payrollMonthExpenseUploadBtnId: useAnalyticId(
    AnalyticIdentifier.ASC_WAGES_LAYOUT_PAYROLL_MONTH_EXPENSE_UPLOAD_BUTTON,
  ),
  payrollMonthExpenseCancelBtnId: useAnalyticId(
    AnalyticIdentifier.ASC_WAGES_LAYOUT_PAYROLL_MONTH_EXPENSE_CANCEL_BUTTON,
  ),
  payrollMonthExpenseUploadInputId: useAnalyticId(
    AnalyticIdentifier.ASC_WAGES_LAYOUT_PAYROLL_MONTH_EXPENSE_UPLOAD_INPUT,
  ),
});
